<!--
 * @Author: wangyunwon
 * @Date: 2025-10-02 17:45:23
 * @Description: 接口环境切换工具，RD、QA专用
-->
<template>
  <div>
    <div
      ref="bar"
      class="toolbar"
      @click.stop="visible = true"
      @touchmove="onTouchmove"
      @touchend="onTouchEnd"
    >
      {{ curEnv }}
    </div>
    <Popup
      v-model="visible"
      title="选择切换环境"
      :ratio="80"
      :z-index="9990"
      :hide-destroy="true"
      @cancel="cancel"
    >
      <rich-radio-group v-model="selectedEnv" :options="options"></rich-radio-group>
      <div v-if="needInput" class="form-item">
        <rich-input
          v-model="inputValue"
          :label="inputLabel"
          class="input"
          type="text"
          :is-error="error"
          @input="onInput"
        />
      </div>
      <div class="submit-button">
        <rich-button type="primary" @click="onEnvSave">保存</rich-button>
      </div>
    </Popup>
  </div>
</template>
<script>
import hostConfig from '@/common/config/hosts.js'
import { Popup } from '@/formily/src'

export default {
  name: 'EnvPicker',
  components: {
    Popup,
  },
  data() {
    const { env, simNum: simHost } = hostConfig
    const simNum = simHost || '060'
    const isSim = env === 'sim'
    const curEnv = isSim ? env + simNum : env
    return {
      inputValue: isSim ? simNum : 'localhost',
      curEnv,
      selectedEnv: env,
      visible: false,
      error: false,
      options: ['production', 'pre', 'sim', 'development'].map(item => {
        return { label: item, value: item }
      }),
    }
  },
  computed: {
    needInput() {
      const selectedEnv = this.selectedEnv
      return selectedEnv === 'sim' || selectedEnv === 'development'
    },
    inputLabel() {
      return this.selectedEnv === 'sim' ? '输入3位数字的sim环境eg：060' : '输入本地前端服务ip'
    },
  },
  watch: {
    selectedEnv(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.needInput) {
          this.inputValue = newVal === 'sim' ? '060' : 'localhost'
        }
      }
    },
  },

  methods: {
    onInput(value) {
      this.error = value.trim().length === 0
    },
    onEnvSave() {
      if (this.error) {
        return
      }
      const protocol = window.location.protocol
      const inputValue = this.inputValue.trim()
      const selectedEnv = this.selectedEnv

      const urls = {
        production: `${protocol}//bd.didi-food.com/`,
        pre: `${protocol}//pre-bd.didi-food.com/`,
        sim: `${protocol}//sim${inputValue}.bd.rlab.sim.intra.xiaojukeji.com`,
        development: `http://${inputValue}:8080`,
      }
      this.visible = false
      this.curEnv = selectedEnv === 'sim' ? selectedEnv + inputValue : selectedEnv
      console.log('curEnv:::', this.curEnv, urls[selectedEnv])
      window.location.assign(urls[selectedEnv])
    },
    onTouchmove(event) {
      const touch = event.targetTouches[0]
      const el = this.$refs.bar
      const width = el.offsetWidth
      const height = el.offsetHeight
      el.style.left = touch.pageX - parseInt(width / 2) + 'px'
      el.style.top = touch.pageY - parseInt(height / 2) + 'px'
    },
    onTouchEnd(e) {
      const touch = e.changedTouches[0]
      const touchLeft = touch.clientX
      const halfScreenWidth = window.innerWidth / 2
      let left
      if (touchLeft < halfScreenWidth) {
        left = 0
      } else if (touchLeft >= halfScreenWidth) {
        left = window.innerWidth - e.target.offsetWidth
      }
      this.$refs.bar.style.left = left + 'px'
    },
    cancel() {
      this.visible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.toolbar {
  position: fixed;
  height: 30px;
  line-height: 30px;
  bottom: 30%;
  left: 0;
  z-index: 9999;
  padding: 12px;
  background-color: #ff6325;
  font-size: 24px;
  color: #fff;
  border-radius: 8px;
  box-shadow: #ccc 0 0 12px 4px;
}
.form-item {
  padding: 0 16px 0 90px;
}
</style>
